import { ShopeeService } from "../resource";
import swal from "sweetalert2";

const PlatformModule = {
    namespaced: true,
    state: {
        datum: {},
    },
    mutations: {
     
    },
    actions: {
        
		// GetOrderShippingDocument({ commit, state }, params) {
		// 	return ShopeeService.OrderPackageDocument(params);
		// },

		// GetPackageShippingDocument({ commit, state }, params) {
		// 	return ShopeeService.OrderPackageDocument(params);
		// },
		
		SyncProduct({ commit, state }, params) {
			return ShopeeService.SyncProduct(params);
		},

		SyncOrder({ commit, state }, params) {
			return ShopeeService.SyncOrder(params);
		},
		ConnectPlatform({ commit, state }, params) {
			return ShopeeService.ConnectPlatform(params);
		},

    },
    getters: {
     
    }
};

export default PlatformModule;
